module.exports = __webpack_public_path__ + "static/media/tm.08d55ec8.svg";